import type { AICodingExecutionStatuses, AICodingJobDetailsDto, AICodingJobDto, CodeframeItemDto } from "app/V2ApiClient";
import { PaginatedQuery, SortDirections, SorterDescriptor } from "app/ApiClient";
import { LoadingState } from "types";

export type VariableStatsVM = {
  total?: number;
  coded?: number;
  notCoded?: number;
};

export type JobInfoVM = {
  variables: string[];
  codingType: string;
  answerType: string;
  translation?: string;
  filter?: string;
};

export type VariableItemVM = {
  batteryName?: string;
  variableNames: string[];
  question: string;
  stats: VariableStatsVM;
  jobInfo: JobInfoVM;
  isExpanded?: boolean;
}

export interface PageContextOfAICodingFilter {
  page?: PaginatedQuery | undefined;
  sortList?: SorterDescriptor[] | undefined;
}

export interface AICodingFilter extends Omit<AICodingJobDto, "jobConfigId" | "jobConfigUuid" | "requestId" | "encodingId" | "jobTypeName" | "jobVariableId" | "variableReportingName" | "jobStatusName" | "startedDate" | "jobMessage"> {
  jobConfigId?: number;
  jobConfigUuid?: string;
  requestId?: string;
  encodingId?: number;
  jobTypeName?: string;
  jobVariableId?: number;
  variableReportingName?: string;
  jobStatusName?: string;
  startedDate?: string;
  jobMessage?: string;
}

export const initialPageContext: PageContextOfAICodingFilter = {
  page: {
    pageNumber: 1,
    pageSize: 10,
  },
  sortList: [{ directions: SortDirections.Desceding, field: "encodingVersion" }],
};

export type AICodingState = {
  
  isAddAICodingJobOpened: boolean;
  createAICodingJobState: LoadingState;
  createdJobConfigId?: number;

  allAiCodingJobs: AICodingJobDto[];
  aiCodingJobsLoading: LoadingState;

  aiCodingJobDetailsDto?: AICodingJobDetailsDto;
  aiCodingJobDetailsLoading: LoadingState;

  quickCodeframeError?: string;
  initiateQuickCodeframeLoading: LoadingState;
  quickCodeframePollingStatus?: AICodingExecutionStatuses;
  quickCodeframeToken?: string;
  aiCodeframeItems?: CodeframeItemDto[];
  codeframeCount?: number;
  currentAICodingJobConfigId?: number;
  codeframeCodedCountByJobConfigId: Record<number, number>;

  variableItemVM?: VariableItemVM;
  variableStatsLoading: LoadingState;
  pageContext: PageContextOfAICodingFilter;
  filters?: { [key in keyof AICodingFilter]: string[] };

  downloadCodeframeResultsLoading: LoadingState;
};

export const initialAICodingState: AICodingState = {
  createAICodingJobState: LoadingState.idle,

  allAiCodingJobs: [],
  aiCodingJobsLoading: LoadingState.idle,

  aiCodingJobDetailsLoading: LoadingState.idle,

  initiateQuickCodeframeLoading: LoadingState.idle,
  quickCodeframePollingStatus: undefined,
  quickCodeframeToken: undefined,
  aiCodeframeItems: undefined,
  codeframeCount: undefined,
  currentAICodingJobConfigId: undefined,
  codeframeCodedCountByJobConfigId: {},
  variableStatsLoading: LoadingState.idle,
  pageContext: initialPageContext,
  filters: undefined,
  isAddAICodingJobOpened: false,

  downloadCodeframeResultsLoading: LoadingState.idle,
};
